// src/utils/date.js
// استفاده شده توسط generateStudentHtml.js
// توابع صادرشده: formatJalaliLong, formatJalaliShort, toPersianDigits

// تبدیل ارقام انگلیسی به فارسی
export function toPersianDigits(input) {
  if (input == null) return '';
  return String(input).replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
}

// تلاش با Intl و fallback به تبدیل دستی جلالی
function supportsIntlJalali() {
  try {
    // اگر محیط از calendar=persian پشتیبانی کند، این باید خروجی متفاوتی تولید کند
    const fmt = new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric' });
    return !!fmt.format;
  } catch {
    return false;
  }
}

// تبدیل میلادی (Gregorian) به جلالی (Jalali / Persian)
// پیاده‌سازی بر اساس الگوریتم شناخته‌شده (Jalaali)
function gregorianToJalali(g_y, g_m, g_d) {
  // g_m: 1..12
  const g_days_in_month = [31, (isLeapGregorian(g_y) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  let gy = g_y - 1600;
  let gm = g_m - 1;
  let gd = g_d - 1;

  let g_day_no = 365 * gy + Math.floor((gy + 3) / 4) - Math.floor((gy + 99) / 100) + Math.floor((gy + 399) / 400);
  for (let i = 0; i < gm; ++i) g_day_no += g_days_in_month[i];
  g_day_no += gd;

  let j_day_no = g_day_no - 79;

  let j_np = Math.floor(j_day_no / 12053);
  j_day_no = j_day_no % 12053;

  let jy = 979 + 33 * j_np + 4 * Math.floor(j_day_no / 1461);
  j_day_no %= 1461;

  if (j_day_no >= 366) {
    jy += Math.floor((j_day_no - 366) / 365);
    j_day_no = (j_day_no - 366) % 365;
  }

  const j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
  let jm = 0;
  for (; jm < 11 && j_day_no >= j_days_in_month[jm]; ++jm) {
    j_day_no -= j_days_in_month[jm];
  }
  const jd = j_day_no + 1;
  return { jy, jm: jm + 1, jd }; // jm: 1..12
}

function isLeapGregorian(y) {
  return (y % 4 === 0 && y % 100 !== 0) || (y % 400 === 0);
}

// نام ماه‌های جلالی (فارسی)
const JALALI_MONTHS = ['فروردین','اردیبهشت','خرداد','تیر','مرداد','شهریور','مهر','آبان','آذر','دی','بهمن','اسفند'];

// فرمت طولانی: "۴ مهر ۱۴۰۴" (اعداد فارسی)
export function formatJalaliLong(isoOrDate) {
  if (!isoOrDate) return '';
  const d = (typeof isoOrDate === 'string' || typeof isoOrDate === 'number') ? new Date(isoOrDate) : isoOrDate;
  if (!d || isNaN(d.getTime())) return '';
  // ابتدا تلاش با Intl
  if (supportsIntlJalali()) {
    try {
      const formatted = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(d);
      return toPersianDigits(formatted);
    } catch {
      // fallback ادامه می‌یابد
    }
  }
  // fallback دستی با الگوریتم تبدیل
  const gY = d.getFullYear();
  const gM = d.getMonth() + 1;
  const gD = d.getDate();
  const { jy, jm, jd } = gregorianToJalali(gY, gM, gD);
  return `${toPersianDigits(jd)} ${JALALI_MONTHS[jm - 1]} ${toPersianDigits(jy)}`;
}

// فرمت کوتاه: "۱۴۰۴/۰۷/۰۴" یا "۰۴/۰۷/۱۴۰۴" — در generateStudentHtml از day/month/year استفاده شده است
export function formatJalaliShort(isoOrDate) {
  if (!isoOrDate) return '';
  const d = (typeof isoOrDate === 'string' || typeof isoOrDate === 'number') ? new Date(isoOrDate) : isoOrDate;
  if (!d || isNaN(d.getTime())) return '';
  if (supportsIntlJalali()) {
    try {
      const parts = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(d);
      const mapping = {};
      parts.forEach(p => { if (p.type !== 'literal') mapping[p.type] = p.value; });
      // خروجی: dd/mm/yyyy
      const out = `${mapping.day}/${mapping.month}/${mapping.year}`;
      return toPersianDigits(out);
    } catch {
      // fallback ادامه می‌یابد
    }
  }
  const gY = d.getFullYear();
  const gM = d.getMonth() + 1;
  const gD = d.getDate();
  const { jy, jm, jd } = gregorianToJalali(gY, gM, gD);
  const pad = (n) => (n < 10 ? '0' + n : '' + n);
  return `${toPersianDigits(pad(jd))}/${toPersianDigits(pad(jm))}/${toPersianDigits(jy)}`;
}
